export interface ITheme {
  title: string
  subTitle: string
  id: ThemeChoices
}

export interface IThemeImgsProps {
  id: string
  img: string
}

export enum ThemeChoices {
  THEME_ID_OBSIDIAN = 'obsidian',
  THEME_ID_METHYST = 'amethyst',
}
